import React, { useState } from 'react';
import {
  Button,
  Grid,
  Icon,
  IconButton,
  LinearProgress,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import DeleteIcon from '@material-ui/icons/Delete';
import { useStyles } from '../styles';
import TicketPopup from '../popups/TicketPopup';
import ReminderPopup from '../popups/ReminderPopup';
import StatusTable from './StatusTable';
import { useTicketDetails } from '../hooks/useTicketDetails';
import { useTickets } from '../hooks/useTickets';

const StatusPage = ({ ticketId, ticketNumber }: any) => {
  const classes = useStyles();
  const { assets, refreshAssets, ticketDetailsLoading } = useTicketDetails(
    ticketId,
    true,
  );
  const { saveNewAssetRequest, sendReminder } = useTickets(false);

  const emptyPopupState = {
    data: {},
    open: false,
    onClose: () => {},
    onSubmit: () => {},
    type: '',
  };

  const [popupState, setPopupState] = useState({
    ...emptyPopupState,
  });

  const handleClosePopup = () => {
    setPopupState(prevState => {
      return {
        ...prevState,
        open: false,
      };
    });
  };

  const handleSubmit = async (type: string, formData: any) => {
    switch (type) {
      case 'edit':
        await saveNewAssetRequest(formData);
        await refreshAssets();
        break;
      case 'reminder':
        await sendReminder(formData);
        await refreshAssets();
        break;
      default:
        console.log('Outside switch');
        break;
    }
    handleClosePopup();
  };

  const handleEditRequest = (data: any) => {
    setPopupState(prevState => {
      return {
        ...prevState,
        open: true,
        data: data,
        type: 'edit',
        onClose: handleClosePopup,
        onSubmit: handleSubmit,
      };
    });
  };

  const handleReminderClick = (data: any) => {
    setPopupState(prevState => {
      return {
        ...prevState,
        open: true,
        data: data,
        type: 'reminder',
        onClose: handleClosePopup,
        onSubmit: handleSubmit,
      };
    });
  };

  return (
    <>
      {ticketDetailsLoading ? (
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      ) : assets?.data?.assets?.filter((asset: any) => asset?.is_new_asset)
          ?.length > 0 ? (
        <>
          <Grid container className={`${classes.flexSpacebetween}`}>
            <Grid item md={4} lg={4}>
              <h1>Check Status</h1>
            </Grid>
            <Grid item md={8} lg={8}>
              <TextField
                variant="outlined"
                select
                label="Component"
                className={classes.assetsDropdown}
              >
                <MenuItem value="Code library">Code library</MenuItem>
                <MenuItem value="Salesforce">Salesforce</MenuItem>
                <MenuItem value="Extension">Extension</MenuItem>
                <MenuItem value="API">API</MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <StatusTable
            loading={ticketDetailsLoading}
            assets={assets}
            ticketId={ticketId}
            refreshAssets={refreshAssets}
            ticketNumber={ticketNumber}
            handleEditRequest={handleEditRequest}
            handleReminderClick={handleReminderClick}
          />
        </>
      ) : (
        <Typography>No new asset requests available.</Typography>
      )}
      {popupState?.open && popupState?.type === 'edit' && (
        <TicketPopup {...popupState} />
      )}
      {popupState?.open && popupState?.type === 'reminder' && (
        <ReminderPopup {...popupState} />
      )}
    </>
  );
};

export default StatusPage;
